@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Booking Fees</h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      Booking Fees can be added onto a customer's purchase to help recover the cost of processing the transaction.
    </p>
    <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
      <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'height': '50px'}" (click)="toggleDisabled()">
      </p-togglebutton>
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="addNew()">
        <span class="pi pi-plus" style="margin-right:8px;"></span>
        <span>Add New</span>
      </button>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table #feeTable
        [value]="ListBookingFees"
        [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true" responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        datakey="bfid">
        <ng-template #header>
          <tr>
            <th width="40px"></th>
            <th width="24%">Name</th>
            <th width="20%">Public Fee</th>
            <th width="20%">Admin Fee</th>
            <th width="10%">Public Applies</th>
            <th width="10%">Admin Applies</th>
            <th width="8%"></th>
            <th width="8%"></th>
          </tr>
        </ng-template>
        <ng-template #body let-data>
          <tr [ngStyle]="{'background-color': data.disabled ? '#fee' : (data.isdefault ? '#e8f4fd' : '#ffffff')}">
            <td>
              <span style="display:inline-block; width:24px; height:24px; border-radius:4px;"
              [style.background-color]="data.colour || '#4CAF50'"></span>
            </td>
            <td>
              @if (data.isdefault) {
                <strong>{{data.name}}</strong>
                }@if (!data.isdefault) {
                <span>{{data.name}}</span>
              }
              @if (data.isdefault) {
                <span style="display:inline-block; margin-left:8px; background-color:#0ea5e9; color:white; padding:2px 10px; border-radius:4px; font-size:0.75rem; font-weight:600; letter-spacing:0.03em;">Default</span>
              }
            </td>
            <td>
              @if (data.bfpublicapply) {
                <span>{{feeDisplay(data.bfpublictype, data.bfpublicfee)}}</span>
              }
              @if (!data.bfpublicapply) {
                <span class="text-400">Not applied</span>
              }
            </td>
            <td>
              @if (data.bfadminapply) {
                <span>{{feeDisplay(data.bfadmintype, data.bfadminfee)}}</span>
              }
              @if (!data.bfadminapply) {
                <span class="text-400">Not applied</span>
              }
            </td>
            <td>
              @if (data.bfpublicapply) {
                <span class="pi pi-check" style="color:green;"></span>
              }
              @if (!data.bfpublicapply) {
                <span class="pi pi-times" style="color:red;"></span>
              }
            </td>
            <td>
              @if (data.bfadminapply) {
                <span class="pi pi-check" style="color:green;"></span>
              }
              @if (!data.bfadminapply) {
                <span class="pi pi-times" style="color:red;"></span>
              }
            </td>
            <td>
              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="editData(data.bfid)">
                <span class="pi pi-pencil" style="margin-right:8px;"></span>
                <span>Edit</span>
              </button>
            </td>
            <td>
              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.bfid)">
                <span class="pi pi-trash" style="margin-right:8px;"></span>
                <span>Disable</span>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="8" style="text-align:center;">No booking fees found. Click <strong>Add New</strong> to create one.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
